import { render, staticRenderFns } from "./Convocatorias.vue?vue&type=template&id=f8406708&"
import script from "./Convocatorias.vue?vue&type=script&lang=js&"
export * from "./Convocatorias.vue?vue&type=script&lang=js&"
import style0 from "./Convocatorias.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports